require('./bootstrap');

import { createApp } from 'vue';
import { Icon } from "leaflet";

import store from './store/store.js';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png').default,
    iconUrl: require('leaflet/dist/images/marker-icon.png').default,
    shadowUrl: require('leaflet/dist/images/marker-shadow.png').default,
});

const app = createApp({});

app.use(store);
app.component('profile-like-button', require('./components/ProfileLikeButton').default)
app.component('location-filter', require('./components/LocationFilter').default)
app.component('address-autocomplete', require('./components/AddressAutocomplete').default)
app.component('company-profiles-map', require('./components/CompanyProfilesMap').default)
app.component('messenger', require('./components/Messenger').default)
app.component('messenger-modal', require('./components/MessengerModal').default)
app.component('messenger-button', require('./components/MessengerButton').default)
app.component('job-search', require('./components/JobSearch').default)
app.component('notification-provider', require('./components/Notification').NotificationProvider)
app.component('job-request-repeater', require('./components/JobRequestRepeater').default)
app.component('graduation-repeater', require('./components/GraduationRepeater').default)
app.component('visibility-selector', require('./components/VisibilitySelector.vue').default)
app.component('graduation-list', require('./components/GraduationList.vue').default)
app.component('navigation', require('./components/Navigation.vue').default)
app.component('collapse', require('./components/Collapse.vue').default)
app.component('applicant-slider', require('./components/ApplicantSlider.vue').default)
app.component('company-slider', require('./components/CompanySlider.vue').default)
app.component('multiselect', require('./components/Multiselect.vue').default)
app.component('job-advertisement-repeater', require('./components/JobAdvertisementRepeater.vue').default)
app.component('create-job-advertisement-modal', require('./components/CreateJobAdvertisementModal.vue').default)
app.component('job-advertisement-list', require('./components/JobAdvertisementList.vue').default)
app.component('price-list', require('./components/PriceList.vue').default)
app.component('order-list', require('./components/OrderList.vue').default)
app.component('message-counter', require('./components/MessageCounter.vue').default)
app.component('filter-menu', require('./components/FilterMenu.vue').default)
app.component('job-search-bar', require('./components/JobSearchBar.vue').default)
app.component('youtube-video', require('./components/YouTubeVideo.vue').default)
app.component('registration-job-request-repeater', require('./components/RegistrationJobRequestRepeater.vue').default)

app.mount('#app');
